module.exports = __webpack_public_path__ + "img/Cert 07.75cf0a3d.png";